import type { HerdAnimal } from './schemas';

export interface HerdColumnDef {
  key: keyof HerdAnimal;
  label: string;
  visible: boolean;
  sortable: boolean;
  editable: boolean;
  width?: string;
  format?: (value: unknown, row: HerdAnimal) => string;
  editType?: 'text' | 'select' | 'number' | 'date';
  editOptions?: string[];
}

export const HERD_COLUMNS: HerdColumnDef[] = [
  {
    key: 'animal_id',
    label: 'Tag',
    visible: true,
    sortable: true,
    editable: false,
    width: '80px',
  },
  {
    key: 'name',
    label: 'Name',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'text',
  },
  {
    key: 'status',
    label: 'Status',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'select',
    editOptions: ['Milking', 'Dry', 'Close-up', 'Heifer', 'Calf'],
  },
  {
    key: 'barn_group',
    label: 'Group',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'text',
  },
  {
    key: 'lactation_number',
    label: 'Lac',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'number',
    width: '60px',
  },
  {
    key: 'dim',
    label: 'DIM',
    visible: true,
    sortable: true,
    editable: false,
    width: '60px',
  },
  {
    key: 'expected_calving_date',
    label: 'Due Date',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'date',
    format: (v) => (v ? new Date(v as string).toLocaleDateString() : '—'),
  },
  {
    key: 'preg_status',
    label: 'Preg',
    visible: true,
    sortable: true,
    editable: true,
    editType: 'select',
    editOptions: ['Open', 'Bred', 'Confirmed', 'Unknown'],
  },
  {
    key: 'sire',
    label: 'Sire',
    visible: false,
    sortable: true,
    editable: true,
    editType: 'text',
  },
  {
    key: 'birth_date',
    label: 'Birth Date',
    visible: false,
    sortable: true,
    editable: true,
    editType: 'date',
  },
  {
    key: 'last_breeding_date',
    label: 'Last Bred',
    visible: false,
    sortable: true,
    editable: false,
  },
  {
    key: 'notes',
    label: 'Notes',
    visible: false,
    sortable: false,
    editable: true,
    editType: 'text',
  },
];

export const DEFAULT_VISIBLE_KEYS = HERD_COLUMNS.filter((c) => c.visible).map((c) => c.key);
